import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { BoltIcon } from "../components/Bolts";

const OrderCancelledPage = () => (
    <div data-testid="order-cancelled-page" className="min-h-[70vh] flex items-center justify-center container-x py-20">
        <div className="text-center max-w-md">
            <XCircle className="w-14 h-14 text-storm-mist mx-auto mb-5" />
            <p className="eyebrow flex items-center justify-center gap-2 mb-3">
                <BoltIcon className="w-3.5 h-3.5" /> Checkout Cancelled
            </p>
            <h1 className="text-3xl md:text-4xl text-white mb-4 leading-tight">
                No charge was made.
            </h1>
            <p className="text-storm-mist mb-8">
                Your cart is still saved — pick up right where you left off whenever you're ready.
            </p>
            <Link to="/" data-testid="order-cancelled-home" className="btn-primary inline-flex">
                Back to shop
            </Link>
        </div>
    </div>
);

export default OrderCancelledPage;
